.inputContainer {
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;
}

.inputContainer > div:nth-child(1) {
  height: 24px;
  line-height: 1.71;
  color: var(--color-easil-gray);
}

.inputContainer > div:nth-child(2) {
  width: 80px;
  height: 32px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding: 0px 13px;
  border-radius: 4px;
  border: solid 1px var(--color-easil-gray-x-light);
}

.inputContainer::after {
  content: "s";
  position: relative;
  right: 7px;
}

@-moz-document url-prefix() {
  .inputContainer::after {
    content: "s";
    position: relative;
    right: 7px;
  }
}

.inputField {
  color: var(--color-easil-black);
  text-align: center;
}

.inputContainer[data-invalid="true"] {
  border-color: var(--color-easil-red) !important;
}
